import { render, staticRenderFns } from "./ImportAlumniName.vue?vue&type=template&id=01b069da&"
import script from "./ImportAlumniName.vue?vue&type=script&lang=js&"
export * from "./ImportAlumniName.vue?vue&type=script&lang=js&"
import style0 from "./ImportAlumniName.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports